<w-block-ui [blocked]="blocked" [title]="'processing' | translate" [text]="'please_wait' | translate"></w-block-ui>

<form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
  <w-page-header title="{{'ipportalDefault.mediation.pageTitle' | translate}}" [disableUppercase]="true"
    [showPortfolio]="false">
  </w-page-header>
  <w-step>
        @if (collaboration !== 'NONE') {
      <p facet-step-info [innerHTML]="'mcstForm.mediation.pageDesc' | translate"></p>
    }
    @if (collaboration === 'NONE') {
      <p facet-step-info [innerHTML]="'ipportalDefault.mediation.pageDesc' | translate">
    }
  </w-step>

  <w-edit-panel>
    <w-section>
      <w-slot>
        <w-input-text label="{{'requestingPartyName' | translate}}" [labelOnTop]="true" [required]="true"
          formControlName="nameComplainant">
                    @if (submitted && f.nameComplainant.errors?.required) {
            <f-facet id="nameComplainantRequired" name="error">{{'validationWarning' | translate
            }}</f-facet>
          }
          @if (submitted && f.nameComplainant.errors?.maxlength) {
            <f-facet id="nameComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'address' | translate}}" [labelOnTop]="true" [required]="true"
          formControlName="addressComplainant">
                    @if (submitted && f.addressComplainant.errors?.required) {
            <f-facet id="addressComplainantRequired" name="error">{{'validationWarning' | translate
            }}</f-facet>
          }
          @if (submitted && f.addressComplainant.errors?.maxlength) {
            <f-facet id="addressComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-select-one id="countryComplainant" [label]="'country' | translate" [labelOnTop]="true" [required]="true"
          formControlName="countryComplainantCode" [options]="optionsCountries">
          @if (submitted && f.countryComplainantCode.errors?.required) {
            <f-facet id="countryComplainantRequired" name="error">{{'validationWarning' | translate }}</f-facet>
          }
        </w-select-one>
        <w-input-text label="{{'tel' | translate}}" [labelOnTop]="true" formControlName="telephoneComplainant">
          @if (submitted && f.telephoneComplainant.errors?.maxlength) {
            <f-facet id="telephoneComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'email' | translate}}" [labelOnTop]="true" [required]="true"
          formControlName="emailComplainant" [type]="'email'">
                    @if (submitted && f.emailComplainant.errors?.required) {
            <f-facet id="emailComplainantRequired" name="error">{{'validationWarning' |
            translate }}
          </f-facet>
          }
          @if (f.emailComplainant.errors?.email) {
            <f-facet id="emailComplainantValidation" name="error">{{'validationEmail' | translate }}</f-facet>
          }
          @if (submitted && f.emailComplainant.errors?.maxlength) {
            <f-facet id="emailComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>

        <w-input-text label="{{'representedBy' | translate}}" [labelOnTop]="true"
          formControlName="representedByComplainant">
          @if (submitted && !validRepresentedByComplainant) {
            <f-facet id="representedByComplainantRequired" name="error">{{'validationWarning' | translate }}</f-facet>
          }
          @if (submitted && f.representedByComplainant.errors?.maxlength) {
            <f-facet id="representedByComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'address' | translate}}" [labelOnTop]="true"
          formControlName="addressRepresentativeComplainant">
          @if (submitted && f.addressRepresentativeComplainant.errors?.maxlength) {
            <f-facet id="addressRepresentativeComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-select-one id="countryComplainantRepBy" [label]="'country' | translate" [labelOnTop]="true"
          formControlName="countryComplainantRepByCode" [options]="optionsCountries">
        </w-select-one>
        <w-input-text label="{{'tel' | translate}}" [labelOnTop]="true"
          formControlName="telephoneRepresentativeComplainant">
          @if (submitted && f.telephoneRepresentativeComplainant.errors?.maxlength) {
            <f-facet id="telephoneRepresentativeComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'email' | translate}}" [labelOnTop]="true"
          formControlName="emailRepresentativeComplainant" [type]="'email'">
                    @if (f.emailRepresentativeComplainant.errors?.email) {
            <f-facet id="emailRepresentativeComplainantValidation" name="error">{{'validationEmail' | translate
            }}
          </f-facet>
          }
          @if (submitted && f.emailRepresentativeComplainant.errors?.maxlength) {
            <f-facet id="emailRepresentativeComplainantLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
      </w-slot>
      <w-slot>
        <w-input-text label="{{'respondingByName' | translate}}" [labelOnTop]="true" formControlName="nameRespondent"
          [required]="true">
                    @if (submitted && f.nameRespondent.errors?.required) {
            <f-facet id="nameRespondentRequired" name="error">{{'validationWarning' | translate
            }}
          </f-facet>
          }
          @if (submitted && f.nameRespondent.errors?.maxlength) {
            <f-facet id="nameRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'address' | translate}}" [labelOnTop]="true" formControlName="addressRespondent"
          [required]="true">
                    @if (submitted && f.addressRespondent.errors?.required) {
            <f-facet id="addressRespondentRequired" name="error">{{'validationWarning' |
            translate }}
          </f-facet>
          }
          @if (submitted && f.addressRespondent.errors?.maxlength) {
            <f-facet id="addressRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-select-one id="countryRespondent" [label]="'country' | translate" [labelOnTop]="true" [required]="true"
          formControlName="countryRespondentCode" [options]="optionsCountries">
          @if (submitted && f.countryRespondentCode.errors?.required) {
            <f-facet id="countryRespondentRequired" name="error">{{'validationWarning' | translate }}</f-facet>
          }
        </w-select-one>
        <w-input-text label="{{'tel' | translate}}" [labelOnTop]="true" formControlName="telephoneRespondent">
          @if (submitted && f.telephoneRespondent.errors?.maxlength) {
            <f-facet id="telephoneRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'email' | translate}}" [labelOnTop]="true" formControlName="emailRespondent"
          [required]="true" [type]="'email'">
                    @if (submitted && f.emailRespondent.errors?.required) {
            <f-facet id="emailRespondentRequired" name="error">{{'validationWarning' |
            translate }}
          </f-facet>
          }
          @if (f.emailRespondent.errors?.email) {
            <f-facet id="emailRespondentValidation" name="error">{{'validationEmail' | translate }}</f-facet>
          }
          @if (submitted && f.emailRespondent.errors?.maxlength) {
            <f-facet id="emailRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>

        <w-input-text label="{{'representedBy' | translate}}" [labelOnTop]="true"
          formControlName="representedByRespondent">
          @if (submitted && !validRepresentedByRespondent) {
            <f-facet id="representedByRespondentRequired" name="error">{{'validationWarning' | translate }}</f-facet>
          }
          @if (submitted && f.representedByRespondent.errors?.maxlength) {
            <f-facet id="representedByRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'address' | translate}}" [labelOnTop]="true"
          formControlName="addressRepresentativeRespondent">
          @if (submitted && f.addressRepresentativeRespondent.errors?.maxlength) {
            <f-facet id="addressRepresentativeRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-select-one id="countryRespondentRepBy" [label]="'country' | translate" [labelOnTop]="true"
          formControlName="countryRespondentRepByCode" [options]="optionsCountries">
        </w-select-one>
        <w-input-text label="{{'tel' | translate}}" [labelOnTop]="true"
          formControlName="telephoneRepresentativeRespondent">
          @if (submitted && f.telephoneRepresentativeRespondent.errors?.maxlength) {
            <f-facet id="telephoneRepresentativeRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text label="{{'email' | translate}}" [labelOnTop]="true"
          formControlName="emailRepresentativeRespondent" [type]="'email'">
                    @if (f.emailRepresentativeRespondent.errors?.email) {
            <f-facet id="emailRepresentativeRespondentValidation" name="error">{{'validationEmail' | translate }}
          </f-facet>
          }
          @if (submitted && f.emailRepresentativeRespondent.errors?.maxlength) {
            <f-facet id="emailRepresentativeRespondentLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
      </w-slot>
    </w-section>
  </w-edit-panel>

</form>

<app-additional-party #additionalPartyForm  [(ngModel)]="additionalParties" [dispCountry]="true"></app-additional-party>
<br><br>

<form [formGroup]="requestOtherForm" (ngSubmit)="onSubmit()">

  <w-edit-panel>
    <w-section>
      <w-slot>
        <w-input-textarea label="{{'disputeMessage' | translate}}" [required]="true" [placeholder]="''"
          formControlName="disputeDescription">
                    @if (submitted && g.disputeDescription.errors?.required) {
            <f-facet id="disputeDescriptionRequired" name="error">{{'validationWarning' | translate
            }}</f-facet>
          }
          @if (submitted && g.disputeDescription.errors?.maxlength) {
            <f-facet id="disputeDescriptionLength" name="error">{{'textLengthWarning' | translate: {value: '18000'} }}</f-facet>
          }
          @if (submitted && g.disputeDescription.errors?.wordCount) {
            <f-facet id="disputeDescriptionWordCount" name="error">{{'ValidateWord' | translate}}</f-facet>
          }
        </w-input-textarea>
      </w-slot>
    </w-section>

    <w-section>
      <f-facet name="header" [innerHTML]="'ipportalDefault.mediation.agreement' | translate"></f-facet>
      <w-slot>
                <w-input-file id="agreementFile" label="{{'annexTitle' | translate}}" [isLarge]="false" [auto]="false" [multiple]="true"
                  [sizeLimit]="10000000" [labelSelect]="'addDocument' | translate"
                  [invalidFileSizeMessageSummary]="'ValidFileSize' | translate" invalidFileSizeMessageDetail="" [showUploadButton]="false" [auto]="false"
                  [required]="true" (wSelected)="onAgreementChange($event)">
                    @if (submitted && g.agreement.errors) {
            <f-facet id="agreementFileRequired" name="error">{{'validationFile' | translate}}</f-facet>
          }
          @if (isTotalSizeExceeded) {
            <f-facet name="error">{{'common.maxUploadAttachment' | translate}}</f-facet>
          }
        </w-input-file>
      </w-slot>
    </w-section>

    <w-section>
            @if (collaboration === 'NONE') {
        <f-facet name="header" [innerHTML]="'ipportalDefault.mediation.proofPayment' | translate"> </f-facet>
      }
      @if (collaboration !== 'NONE') {
        <f-facet name="header" [innerHTML]="'mcstForm.mediation.proofPayment' | translate"> </f-facet>
      }
      <w-slot>
                <w-input-file label="{{'annexTitle' | translate}}" [isLarge]="false" [auto]="false" [multiple]="true"
                  [sizeLimit]="10000000" [labelSelect]="'addDocument' | translate"
                  [invalidFileSizeMessageSummary]="'ValidFileSize' | translate" invalidFileSizeMessageDetail="" [showUploadButton]="false" [auto]="false"
                  (wSelected)="onPaymentChange($event)">
          @if (isTotalSizeExceeded) {
            <f-facet name="error">{{'common.maxUploadAttachment' | translate}}</f-facet>
          }
        </w-input-file>
      </w-slot>
    </w-section>

    <w-section>
      <f-facet name="header">{{ 'otherDocIfAny' | translate }}</f-facet>
      <w-slot>
                <w-input-file label="{{'annexTitle' | translate}}" [isLarge]="false" [auto]="false" [multiple]="true"
                  [sizeLimit]="10000000" [labelSelect]="'addDocument' | translate"
                  [invalidFileSizeMessageSummary]="'ValidFileSize' | translate" invalidFileSizeMessageDetail="" [showUploadButton]="false" [auto]="false"
                  (wSelected)="onAttachmentChange($event)">
          @if (isTotalSizeExceeded) {
            <f-facet name="error">{{'common.maxUploadAttachment' | translate}}</f-facet>
          }
        </w-input-file>
      </w-slot>
    </w-section>

    <w-section>
      <w-slot>
        <w-input-text label="{{'submittingIndividual' | translate}}" [labelOnTop]="true" [required]="true"
          formControlName="signature">
                    @if (submitted && g.signature.errors?.required) {
            <f-facet id="signatureRequired" name="error">{{'validationWarning' | translate }}</f-facet>
          }
          @if (submitted && g.signature.errors?.maxlength) {
            <f-facet id="signatureLength" name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
      </w-slot>
    </w-section>
  </w-edit-panel>




</form>


<f-facet name="step-info">
  <w-page-header [disableUppercase]="true" [showPortfolio]="false">
    <f-facet name="actions">
      <button id="submit" w-button [isDefault]="true" [isSecondary]="false" [disabled]="false" [buttonType]="'text'" 
        type="submit" (click)="onSubmit()">
        {{ 'submitRequest' | translate }}
      </button>
    </f-facet>
  </w-page-header>
  <br><br>
</f-facet>

@if (isOpen) {
  <w-dialog [style]="style">
  <w-step [title]="'ipportalDefault.mediation.alerTitle' | translate" [reviewMode]="true">
    <div facet-step-info [innerHTML]="'ipportalDefault.mediation.alerText' | translate"></div>
    <button w-button (click)="closeDialogbox()" facet-step-actions>OK</button>
  </w-step>
</w-dialog>
}